import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'

export const getBusinessDescriptions = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getBusinessDescriptions()
}

// Do Not Remove this line ===@import api client===
